import { CashCodingModel } from '@app/core/Models';

export class CreateCashCoding {
  static readonly type = '[CASHCODING] Create Cash Coding';

  constructor(public cashCoding: CashCodingModel[]) {}
}
